import i18next from "i18next";
import { isRef, isSchema } from "joi";
import { get, replace, set } from "lodash";
import moment from "moment";

const dateFormat = "DD.MM.YYYY";

export const joiResolver =
    (schema, options = {}) =>
    async (data) => {
        const { error, value: formValues } = isSchema(schema)
            ? schema.validate(data, {
                  abortEarly: false,
                  ...options,
              })
            : { value: data };

        if (process.env.NODE_ENV == "development")
            console.debug(
                "VALIDATION ERROR DETAILS",
                error?.details,
                schema?._ids?._byKey?.get("end_time")?.schema?._flags?.label
            );
        return {
            values: formValues,
            errors: error
                ? error.details.reduce((previous, currentError) => {
                      let message = currentError.message.includes("***")
                          ? currentError.message.replace("***", "")
                          : i18next.t(currentError.type, currentError.message, {
                                ...Object.entries(currentError.context).reduce((carry, [key, value]) => {
                                    // render ref dates
                                    if (key === "limit" && typeof value instanceof Date)
                                        if (value.render)
                                            return {
                                                ...carry,
                                                [key]: moment(get(formValues, value.path)).format(dateFormat),
                                            };
                                        else
                                            return {
                                                ...carry,
                                                [key]: schema._ids?._byKey.get(value.key)?.schema._flags?.label,
                                            };

                                    // render dates
                                    if (isRef(value) && value.render) {
                                        let refPath = currentError.path;
                                        refPath[refPath.length - 1] = value.key;

                                        return {
                                            ...carry,
                                            [key]: moment(get(formValues, refPath.join("."))).format(dateFormat),
                                        };
                                    }

                                    if (value instanceof Date)
                                        return {
                                            ...carry,
                                            [key]: moment(value).format(dateFormat),
                                        };

                                    return { ...carry, [key]: value };
                                }, {}),
                                defaultValue: currentError.message,
                                ns: "validation",
                            });

                      // check for ref: string and replace with label
                      const matches = message?.match(/(ref:[a-zA-Z0-9-_]+)/gm);
                      if (matches?.length > 0) {
                          const key = matches[0].replace("ref:", "");
                          const replacement = schema?._ids?._byKey.get(key)?.schema._flags?.label;
                          if (replacement) message = message.replace(matches[0], replacement);
                      }

                      return set(previous, currentError.path.join("."), {
                          ...currentError,
                          message,
                      });
                  }, {})
                : {},
        };
    };
